import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Container} from "reactstrap";

import ConfirmEmail from './ConfirmEmail';
import ConfirmPhone from './ConfirmPhone';
import ChangeNotifications from './ChangeNotifications';
import ChangePassword from "./ChangePassword";
import DefaultMessages from './DefaultMessages';
import TenantGroupPreferences from './TenantGroupPreferences';

class SettingsContainer extends Component {
    render() {
        return (
            <div>
                <Container>
                    <h3 className="mt-4 mb-0">Account Settings</h3>
                    <hr />
                    <ConfirmEmail/>
                    <ConfirmPhone/>
                    <ChangeNotifications/>
                    <TenantGroupPreferences/>
                    <DefaultMessages/>
                    <ChangePassword/>
                </Container>
            </div>
        );
    }

}

export default connect()(SettingsContainer);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsContainer.js